import React from "react";
import Logo from "../components/Logo";
import Testimonials from "../components/Testimonials.js";

function LandingPage(props) {
    return (
        <div className="flex flex-col h-full">
            <Logo />
            <Testimonials />
        </div>
    );
}

export default LandingPage;
